import { apiClient, ApiResponse } from './client';
import type { Transaction, PaginatedResponse } from '../types';

export interface UserStatistics {
  nftsOwned: number;
  activeOffers: number;
  completedSales: number;
  totalVolume: number;
}

/**
 * Fetch user statistics (NFTs owned, active offers, sales, volume)
 */
export async function getUserStatistics(address: string): Promise<UserStatistics> {
  try {
    const response = await apiClient.get<ApiResponse<UserStatistics>>(`/users/${address}/statistics`);

    if (!response.success || !response.data) {
      throw new Error(response.error || 'Failed to fetch user statistics');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching user statistics:', error);
    throw error;
  }
}

/**
 * Fetch user trading history with pagination
 */
export async function getUserTransactions(
  address: string,
  page: number = 1,
  limit: number = 20
): Promise<PaginatedResponse<Transaction>> {
  try {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });

    const response = await apiClient.get<ApiResponse<PaginatedResponse<Transaction>>>(
      `/users/${address}/transactions?${params.toString()}`
    );

    if (!response.success || !response.data) {
      throw new Error(response.error || 'Failed to fetch user transactions');
    }

    return response.data;
  } catch (error) {
    console.error('Error fetching user transactions:', error);
    throw error;
  }
}

/**
 * Update user profile (display name)
 */
export async function updateUserProfile(address: string, updates: { displayName?: string }): Promise<void> {
  try {
    const response = await apiClient.put<ApiResponse<void>>(`/users/${address}`, updates);

    if (!response.success) {
      throw new Error(response.error || 'Failed to update user profile');
    }
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
}
